export const Title = () => (
    <h5 className="my-4 text-gradient text-dark text-center">
        Your tradesperson has requested approval for the following
    </h5>
);